import { Box } from '@mui/material';
import { useMemo, useState } from 'react';
import Dashboard from './dashboard/Dashboard';
import Navigation from './navigation/Navigation';
import PreferenceContext from '../context/PreferenceContext';

const Public = () => {
  const [preferenceID, setPreferenceID] = useState<number>(0);
  const preferenceValue = useMemo(() => ({ preferenceID, setPreferenceID }), [preferenceID]);

  return (
    <PreferenceContext.Provider value={preferenceValue} >
      <Box className='d-flex flex-column '>
        <Navigation />
        <Box className='w-100 flex-column'>
          <Dashboard />
        </Box>
      </Box>
    </PreferenceContext.Provider>
  );
};

export default Public;
